module.exports = __webpack_public_path__ + "img/detailed.721c161d.jpg";